// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"797":"69297666","1293":"69297666","5631":"69297666","7329":"69297666","7902":"69297666","8712":"69297666","9983":"69297666"}[chunkId] + ".chunk.css";
};